import { attachDialog } from '../../util/dialog_helpers.js';
import { attachEventHandlers } from '../mixins/PreventModalEscape.js';

/**
 * Show the suspended account dialog
 * @returns {Promise<void>}
 */
export const showSuspendedAccountDialog = async () => {
  try {
    const { dialog, dialogPromise } = await attachDialog('account_suspended_dialog');

    attachEventHandlers(dialog);

    return dialogPromise;
  } catch (error) {
    console.error('Error fetching dialog template:', error);
    throw error;
  }
};
